import { render, staticRenderFns } from "./NavbarLink.vue?vue&type=template&id=90ef83c8&scoped=true"
import script from "./NavbarLink.vue?vue&type=script&lang=js"
export * from "./NavbarLink.vue?vue&type=script&lang=js"
import style0 from "./NavbarLink.vue?vue&type=style&index=0&id=90ef83c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ef83c8",
  null
  
)

export default component.exports